module.exports = __webpack_public_path__ + "static/media/banner-campuscape.f5482255.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner-campuscape.png
// module id = 425
// module chunks = 0